(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1228],{

/***/ 63544:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/donatie-impreuna",
      function () {
        return __webpack_require__(9285);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ donatie_impreuna; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(65988);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 10 modules
var es = __webpack_require__(26209);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./lib/api/index.js
var api = __webpack_require__(2642);
// EXTERNAL MODULE: ./lib/helpers.js
var helpers = __webpack_require__(15722);
// EXTERNAL MODULE: ./store/app/actions.js
var actions = __webpack_require__(27173);
// EXTERNAL MODULE: ./store/cart/actions.js
var cart_actions = __webpack_require__(30500);
// EXTERNAL MODULE: ./containers/ErrorPage.js
var ErrorPage = __webpack_require__(75720);
// EXTERNAL MODULE: ./components/Loading.js
var Loading = __webpack_require__(24461);
// EXTERNAL MODULE: ./components/ContentEditorView/index.js + 24 modules
var ContentEditorView = __webpack_require__(51961);
// EXTERNAL MODULE: ./components/Button.js
var Button = __webpack_require__(52077);
// EXTERNAL MODULE: ./containers/DonationForm.js
var DonationForm = __webpack_require__(33989);
;// CONCATENATED MODULE: ./components/AmountFlipCounter.js


var AmountFlipCounter = function(param) {
    var amount = param.amount;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        className: "text-4xl text-white leading-none font-bold",
        children: [
            amount.toFixed(0).toString().split("").map(function(number, index) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)("span", {
                    className: "inline-block px-2 rounded align-middle",
                    style: {
                        backgroundColor: "#FDCD1A",
                        marginRight: "2px",
                        lineHeight: "39px"
                    },
                    children: number
                }, index);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "inline-block px-1 rounded text-sm text-base align-middle",
                style: {
                    backgroundColor: "#FDCD1A",
                    marginRight: "2px",
                    lineHeight: "39px"
                },
                children: "RON"
            })
        ]
    });
};
/* harmony default export */ var components_AmountFlipCounter = (AmountFlipCounter);

;// CONCATENATED MODULE: ./pages/donatie-impreuna.js



















function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var ref = (0,config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, _settings = _publicRuntimeConfig.settings, websiteStatics = _settings.websiteStatics, baseUrl = _settings.baseUrl, websiteName = _settings.websiteName, localSeller = _settings.localSeller, content = _publicRuntimeConfig.content;
var DonatieCovid19 = /*#__PURE__*/ function(Component1) {
    "use strict";
    _inherits(DonatieCovid19, Component1);
    var _super = _createSuper(DonatieCovid19);
    function DonatieCovid19(props) {
        _classCallCheck(this, DonatieCovid19);
        var _this;
        _this = _super.call(this, props);
        var _this1 = _assertThisInitialized(_this);
        _defineProperty(_assertThisInitialized(_this), "sessionData", _asyncToGenerator(runtime_default().mark(function _callee1() {
            return runtime_default().wrap(function _callee$(_ctx1) {
                while(1)switch(_ctx1.prev = _ctx1.next){
                    case 0:
                        if (!_this1.state.ready && !_this1.state.fetching) {
                            _this1.setState({
                                fetching: true
                            }, _asyncToGenerator(runtime_default().mark(function _callee() {
                                var cartReq, dummyCartReq;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            if (_this1.props.cart.isInitial) {
                                                _ctx.next = 13;
                                                break;
                                            }
                                            if (!_this1.props.cart.token) {
                                                _ctx.next = 8;
                                                break;
                                            }
                                            _ctx.next = 4;
                                            return _this1.props.getCart();
                                        case 4:
                                            cartReq = _ctx.sent;
                                            if (cartReq) {
                                                _this1.setState({
                                                    cart: cartReq.cart,
                                                    ready: true,
                                                    fetching: false
                                                });
                                            }
                                            _ctx.next = 13;
                                            break;
                                        case 8:
                                            ;
                                            _ctx.next = 11;
                                            return _this1.props.getDummyCart();
                                        case 11:
                                            dummyCartReq = _ctx.sent;
                                            if (dummyCartReq) {
                                                ;
                                                _this1.setState({
                                                    cart: dummyCartReq.cart,
                                                    ready: true,
                                                    fetching: false
                                                });
                                            }
                                        case 13:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            })));
                        }
                    case 1:
                    case "end":
                        return _ctx1.stop();
                }
            }, _callee1);
        })));
        var _this2 = _assertThisInitialized(_this);
        _defineProperty(_assertThisInitialized(_this), "addDonationToCart", function() {
            var _ref = _asyncToGenerator(runtime_default().mark(function _callee(sum) {
                var donationSku, payload, addResponse, cartToken;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            donationSku = get_default()(_this2.state, "cart.donation_options.sku", null) || get_default()(_this2.props, "cart.miniCart.donation_options.sku", null);
                            if (donationSku && sum) {
                                _ctx.next = 3;
                                break;
                            }
                            return _ctx.abrupt("return", null);
                        case 3:
                            payload = {
                                sku: donationSku,
                                donation: sum,
                                // sku: 'SMTMWC22RMA',
                                quantity: 1,
                                seller_id: localSeller
                            };
                            _this2.props.addSpinner("placeDonation", "Trimitere donatie...");
                            _ctx.next = 7;
                            return _this2.props.apiCall({
                                spinner: false,
                                alert: true,
                                apiCall: api/* addToCartApi */.kLC,
                                apiArgs: [
                                    payload
                                ],
                                returnResponse: true
                            });
                        case 7:
                            addResponse = _ctx.sent;
                            _this2.props.removeSpinner("placeDonation");
                            if (!(addResponse && addResponse.ok)) {
                                _ctx.next = 15;
                                break;
                            }
                            cartToken = get_default()(addResponse, "data.cart.token", false);
                            if (!cartToken) {
                                _ctx.next = 15;
                                break;
                            }
                            _ctx.next = 14;
                            return _this2.props.initCartToken(cartToken);
                        case 14:
                            router["default"].push("/cos-cumparaturi/");
                        case 15:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(sum) {
                return _ref.apply(this, arguments);
            };
        }());
        _this.state = {
            initialValues: {
                customer_type: 1,
                address_type: 1
            },
            initialAddress: false,
            ready: false,
            fetching: false,
            donation: "",
            altaSuma: false,
            altaSumaValidation: false,
            showAdd: false,
            showNews: false
        };
        _this.partnersDonations = [
            {
                name: "UniCredit Bank",
                amount: 631192
            },
            {
                name: "Whirlpool",
                amount: 146252
            },
            {
                name: "De'Longhi",
                amount: 100000
            },
            {
                name: "Hama",
                amount: 48400
            },
            {
                name: "Media Invest",
                amount: 48400
            },
            {
                name: "PC-coolers",
                amount: 35000
            }, 
        ];
        _this.partnersDonationsAmount = _this.partnersDonations.reduce(function(totalAmount, donation) {
            return totalAmount + donation.amount;
        }, 0);
        _this.otherDonationsAmount = 508200;
        return _this;
    }
    _createClass(DonatieCovid19, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                return _asyncToGenerator(runtime_default().mark(function _callee() {
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _this.sessionData();
                            case 1:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                var _this = this;
                return _asyncToGenerator(runtime_default().mark(function _callee() {
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _this.sessionData();
                            case 1:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, cmsObjBlocks = _props.cmsObjBlocks, storeCart = _props.cart, donationReport = _props.donationReport;
                var _state = this.state, ready = _state.ready, showNews = _state.showNews;
                var cart = storeCart.miniCart ? storeCart.miniCart : this.state.cart;
                if (websiteName !== "altex") {
                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* default */.Z, {
                        layout: "404"
                    }));
                }
                var donationSums = get_default()(cart, "donation_options.sums", null);
                var donatedSum = null;
                if (cart && cart.donation) {
                    var donationSku = Object.keys(cart.cart_items).find(function(it) {
                        return it.indexOf("DONATIECOVID") > -1;
                    });
                    donatedSum = cart.cart_items[donationSku].total;
                }
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(head["default"], {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                                    children: "Donatie #impreuna"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                    name: "description",
                                    content: "Doneaza si tu alaturi de Altex pentru lupta impotriva COVID-19. #impreuna"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: style_default().dynamic([
                                [
                                    "f7cc29c296bf819b",
                                    [
                                        websiteStatics,
                                        websiteStatics,
                                        websiteStatics
                                    ]
                                ]
                            ]),
                            children: [
                                (0,jsx_runtime.jsx)((style_default()), {
                                    id: "f7cc29c296bf819b",
                                    dynamic: [
                                        websiteStatics,
                                        websiteStatics,
                                        websiteStatics
                                    ],
                                    children: ".cmsDonatie{margin-left:10px;\nmargin-right:10px;\nfont-size:16px;\nfont-weight:100;\nline-height:1.5}\n.cmsDonatie p{font-size:16px;\nfont-weight:100;\nline-height:1.5}\n.cmsDonatie p b{font-weight:bold}\n.cmsDonatie ul{list-style-image:url(\"".concat(websiteStatics, "/images/donatii-covid-v2/altex-star-list.png\")}\n.cmsDonatie li{font-size:1rem;\nline-height:1.5}\n.cmsDonatie h2, .cmsDonatie h2 *, .cmsDonatie h3, .cmsDonatie h3 *{text-align:left;\ncolor:#d71440;\nfont-size:32px;\nfont-family:Trebuchet MS, Helvetica Neue, Helvetica, Arial, sans-serif;\ntext-transform:inherit;\nletter-spacing:normal;\nline-height:1.2}\n.cmsDonatie h2, .cmsDonatie h3{margin-top:0.75em}\n.cmsDonatie h2:after, .cmsDonatie h3:after{content:\"\";\ndisplay:block;\nwidth:60px;\nheight:2px;\nbackground-color:#f5cb38;\nmargin-top:10px}\n.DonatiePageForm{background:#e7991b url(\"").concat(websiteStatics, "/images/donatii-covid-v3/donation_bg.jpg\") no-repeat center center;\nbackground-size:cover}\n._DonatieHeader{background-color:#fff;\nbackground-image:url(\"").concat(websiteStatics, "/images/donatii-covid-v2/oameni2.jpg\");\nbackground-repeat:no-repeat;\nbackground-position:center top}\n._DonatieHeader::after{content:\"\";\nposition:absolute;\nleft:0;\nright:0;\nbottom:0;\nheight:20px;\nbackground:rgb(255, 255, 255);\nbackground: linear-gradient(\n                0deg,\n                rgba(255, 255, 255, 1) 0%,\n                rgba(255, 255, 255, 0) 100%\n              )}")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: style_default().dynamic([
                                        [
                                            "f7cc29c296bf819b",
                                            [
                                                websiteStatics,
                                                websiteStatics,
                                                websiteStatics
                                            ]
                                        ]
                                    ]) + " " + "container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: style_default().dynamic([
                                            [
                                                "f7cc29c296bf819b",
                                                [
                                                    websiteStatics,
                                                    websiteStatics,
                                                    websiteStatics
                                                ]
                                            ]
                                        ]),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "#doneaza-si-tu",
                                            className: style_default().dynamic([
                                                [
                                                    "f7cc29c296bf819b",
                                                    [
                                                        websiteStatics,
                                                        websiteStatics,
                                                        websiteStatics
                                                    ]
                                                ]
                                            ]),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "".concat(websiteStatics, "/images/donatii-covid-v3/top.jpg"),
                                                alt: content.websiteTitle,
                                                width: "1000",
                                                height: "600",
                                                className: style_default().dynamic([
                                                    [
                                                        "f7cc29c296bf819b",
                                                        [
                                                            websiteStatics,
                                                            websiteStatics,
                                                            websiteStatics
                                                        ]
                                                    ]
                                                ]) + " " + "block mx-auto"
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        maxWidth: 740
                                    },
                                    className: style_default().dynamic([
                                        [
                                            "f7cc29c296bf819b",
                                            [
                                                websiteStatics,
                                                websiteStatics,
                                                websiteStatics
                                            ]
                                        ]
                                    ]) + " " + "container mx-auto text-black",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "".concat(websiteStatics, "/images/donatii-covid-v3/impreuna.jpg"),
                                        width: "740",
                                        height: "212",
                                        className: style_default().dynamic([
                                            [
                                                "f7cc29c296bf819b",
                                                [
                                                    websiteStatics,
                                                    websiteStatics,
                                                    websiteStatics
                                                ]
                                            ]
                                        ]) + " " + "block mx-auto my-4"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: style_default().dynamic([
                                        [
                                            "f7cc29c296bf819b",
                                            [
                                                websiteStatics,
                                                websiteStatics,
                                                websiteStatics
                                            ]
                                        ]
                                    ]) + " " + "lg:flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: style_default().dynamic([
                                                [
                                                    "f7cc29c296bf819b",
                                                    [
                                                        websiteStatics,
                                                        websiteStatics,
                                                        websiteStatics
                                                    ]
                                                ]
                                            ]) + " " + "lg:w-3/12"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            style: {
                                                maxWidth: 700
                                            },
                                            className: style_default().dynamic([
                                                [
                                                    "f7cc29c296bf819b",
                                                    [
                                                        websiteStatics,
                                                        websiteStatics,
                                                        websiteStatics
                                                    ]
                                                ]
                                            ]) + " " + "container mx-auto text-black lg:w-6/12",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    style: {
                                                        maxWidth: 700
                                                    },
                                                    className: style_default().dynamic([
                                                        [
                                                            "f7cc29c296bf819b",
                                                            [
                                                                websiteStatics,
                                                                websiteStatics,
                                                                websiteStatics
                                                            ]
                                                        ]
                                                    ]) + " " + "text-center mb-6 mx-auto",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: style_default().dynamic([
                                                            [
                                                                "f7cc29c296bf819b",
                                                                [
                                                                    websiteStatics,
                                                                    websiteStatics,
                                                                    websiteStatics
                                                                ]
                                                            ]
                                                        ]) + " " + "cmsDonatie text-left",
                                                        children: !!cmsObjBlocks.donatie_covid && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentEditorView/* default */.Z, {
                                                            content: cmsObjBlocks.donatie_covid
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: style_default().dynamic([
                                                        [
                                                            "f7cc29c296bf819b",
                                                            [
                                                                websiteStatics,
                                                                websiteStatics,
                                                                websiteStatics
                                                            ]
                                                        ]
                                                    ]) + " " + "mt-4 mb-6 px-3 w-full block hidden sm:block",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "".concat(websiteStatics, "/images/donatii-covid-v3/sponsori.png"),
                                                        width: "680",
                                                        height: "240",
                                                        className: style_default().dynamic([
                                                            [
                                                                "f7cc29c296bf819b",
                                                                [
                                                                    websiteStatics,
                                                                    websiteStatics,
                                                                    websiteStatics
                                                                ]
                                                            ]
                                                        ]) + " " + "w-full"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: style_default().dynamic([
                                                        [
                                                            "f7cc29c296bf819b",
                                                            [
                                                                websiteStatics,
                                                                websiteStatics,
                                                                websiteStatics
                                                            ]
                                                        ]
                                                    ]) + " " + "mt-4 mb-6 px-12 w-full block sm:hidden",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "".concat(websiteStatics, "/images/donatii-covid-v3/sponsori-mobile.png"),
                                                        width: "360",
                                                        height: "400",
                                                        className: style_default().dynamic([
                                                            [
                                                                "f7cc29c296bf819b",
                                                                [
                                                                    websiteStatics,
                                                                    websiteStatics,
                                                                    websiteStatics
                                                                ]
                                                            ]
                                                        ]) + " " + "w-full"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: style_default().dynamic([
                                                [
                                                    "f7cc29c296bf819b",
                                                    [
                                                        websiteStatics,
                                                        websiteStatics,
                                                        websiteStatics
                                                    ]
                                                ]
                                            ]) + " " + "lg:w-3/12"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    id: "doneaza-si-tu",
                                    className: style_default().dynamic([
                                        [
                                            "f7cc29c296bf819b",
                                            [
                                                websiteStatics,
                                                websiteStatics,
                                                websiteStatics
                                            ]
                                        ]
                                    ]) + " " + "lg:flex DonatiePageForm",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: style_default().dynamic([
                                                [
                                                    "f7cc29c296bf819b",
                                                    [
                                                        websiteStatics,
                                                        websiteStatics,
                                                        websiteStatics
                                                    ]
                                                ]
                                            ]) + " " + "lg:w-3/12"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: style_default().dynamic([
                                                [
                                                    "f7cc29c296bf819b",
                                                    [
                                                        websiteStatics,
                                                        websiteStatics,
                                                        websiteStatics
                                                    ]
                                                ]
                                            ]) + " " + "container mx-auto text-black lg:w-6/12 py-16",
                                            children: ready ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: cart && cart.donation ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: style_default().dynamic([
                                                                [
                                                                    "f7cc29c296bf819b",
                                                                    [
                                                                        websiteStatics,
                                                                        websiteStatics,
                                                                        websiteStatics
                                                                    ]
                                                                ]
                                                            ]),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: "".concat(websiteStatics, "/images/donatii-covid-v2/success-icon.png"),
                                                                width: "416",
                                                                height: "245",
                                                                className: style_default().dynamic([
                                                                    [
                                                                        "f7cc29c296bf819b",
                                                                        [
                                                                            websiteStatics,
                                                                            websiteStatics,
                                                                            websiteStatics
                                                                        ]
                                                                    ]
                                                                ]) + " " + "block mx-auto pr-8"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: style_default().dynamic([
                                                                [
                                                                    "f7cc29c296bf819b",
                                                                    [
                                                                        websiteStatics,
                                                                        websiteStatics,
                                                                        websiteStatics
                                                                    ]
                                                                ]
                                                            ]) + " " + "text-black text-center text-3xl leading-normal font-thin",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                className: style_default().dynamic([
                                                                    [
                                                                        "f7cc29c296bf819b",
                                                                        [
                                                                            websiteStatics,
                                                                            websiteStatics,
                                                                            websiteStatics
                                                                        ]
                                                                    ]
                                                                ]),
                                                                children: [
                                                                    "In acest moment ai in cos o donatie in valoare de",
                                                                    " ",
                                                                    donatedSum,
                                                                    " lei"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: style_default().dynamic([
                                                                [
                                                                    "f7cc29c296bf819b",
                                                                    [
                                                                        websiteStatics,
                                                                        websiteStatics,
                                                                        websiteStatics
                                                                    ]
                                                                ]
                                                            ]) + " " + "text-center",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                title: "Vezi cosul tau",
                                                                display: "inline",
                                                                size: "normal",
                                                                variant: "primary",
                                                                href: "".concat(baseUrl, "/cos-cumparaturi/")
                                                            })
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DonationForm/* default */.Z, {
                                                        donationSums: donationSums,
                                                        addDonationToCart: this.addDonationToCart
                                                    })
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {
                                                height: 100
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: style_default().dynamic([
                                                [
                                                    "f7cc29c296bf819b",
                                                    [
                                                        websiteStatics,
                                                        websiteStatics,
                                                        websiteStatics
                                                    ]
                                                ]
                                            ]) + " " + "lg:w-3/12"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: style_default().dynamic([
                                        [
                                            "f7cc29c296bf819b",
                                            [
                                                websiteStatics,
                                                websiteStatics,
                                                websiteStatics
                                            ]
                                        ]
                                    ]) + " " + "lg:flex",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: style_default().dynamic([
                                                [
                                                    "f7cc29c296bf819b",
                                                    [
                                                        websiteStatics,
                                                        websiteStatics,
                                                        websiteStatics
                                                    ]
                                                ]
                                            ]) + " " + "lg:w-2/12"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            style: {
                                                maxWidth: 700
                                            },
                                            className: style_default().dynamic([
                                                [
                                                    "f7cc29c296bf819b",
                                                    [
                                                        websiteStatics,
                                                        websiteStatics,
                                                        websiteStatics
                                                    ]
                                                ]
                                            ]) + " " + "container mx-auto text-black lg:w-8/12",
                                            children: [
                                                !!(donationReport && donationReport.amount) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: style_default().dynamic([
                                                        [
                                                            "f7cc29c296bf819b",
                                                            [
                                                                websiteStatics,
                                                                websiteStatics,
                                                                websiteStatics
                                                            ]
                                                        ]
                                                    ]) + " " + "py-4",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                        className: style_default().dynamic([
                                                            [
                                                                "f7cc29c296bf819b",
                                                                [
                                                                    websiteStatics,
                                                                    websiteStatics,
                                                                    websiteStatics
                                                                ]
                                                            ]
                                                        ]) + " " + "text-center text-4xl mb-4",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: style_default().dynamic([
                                                                    [
                                                                        "f7cc29c296bf819b",
                                                                        [
                                                                            websiteStatics,
                                                                            websiteStatics,
                                                                            websiteStatics
                                                                        ]
                                                                    ]
                                                                ]),
                                                                children: "Pana in acest moment s-au donat"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: style_default().dynamic([
                                                                    [
                                                                        "f7cc29c296bf819b",
                                                                        [
                                                                            websiteStatics,
                                                                            websiteStatics,
                                                                            websiteStatics
                                                                        ]
                                                                    ]
                                                                ]) + " " + "text-red-brand text-5xl sm:text-6xl mt-4 font-extrabold u-text-headings-font u-text-bold",
                                                                children: [
                                                                    "".concat((0,helpers/* formatPrice */.T4)(donationReport.amount + this.partnersDonationsAmount + this.otherDonationsAmount, "int")),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: style_default().dynamic([
                                                                            [
                                                                                "f7cc29c296bf819b",
                                                                                [
                                                                                    websiteStatics,
                                                                                    websiteStatics,
                                                                                    websiteStatics
                                                                                ]
                                                                            ]
                                                                        ]) + " " + "text-5xl ml-1",
                                                                        children: "LEI"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                donationReport && donationReport.last_orders && donationReport.last_orders.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: style_default().dynamic([
                                                        [
                                                            "f7cc29c296bf819b",
                                                            [
                                                                websiteStatics,
                                                                websiteStatics,
                                                                websiteStatics
                                                            ]
                                                        ]
                                                    ]) + " " + "cmsDonatie mb-16",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                            className: style_default().dynamic([
                                                                [
                                                                    "f7cc29c296bf819b",
                                                                    [
                                                                        websiteStatics,
                                                                        websiteStatics,
                                                                        websiteStatics
                                                                    ]
                                                                ]
                                                            ]) + " " + "font-bold",
                                                            children: "Cele mai recente donatii"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                            className: style_default().dynamic([
                                                                [
                                                                    "f7cc29c296bf819b",
                                                                    [
                                                                        websiteStatics,
                                                                        websiteStatics,
                                                                        websiteStatics
                                                                    ]
                                                                ]
                                                            ]) + " " + "mt-6 pl-0 text-xs",
                                                            children: donationReport.last_orders.map(function(donationItem, i) {
                                                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("li", {
                                                                    style: {
                                                                        listStyleImage: "none"
                                                                    },
                                                                    className: style_default().dynamic([
                                                                        [
                                                                            "f7cc29c296bf819b",
                                                                            [
                                                                                websiteStatics,
                                                                                websiteStatics,
                                                                                websiteStatics
                                                                            ]
                                                                        ]
                                                                    ]) + " " + "mb-5",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                            className: style_default().dynamic([
                                                                                [
                                                                                    "f7cc29c296bf819b",
                                                                                    [
                                                                                        websiteStatics,
                                                                                        websiteStatics,
                                                                                        websiteStatics
                                                                                    ]
                                                                                ]
                                                                            ]) + " " + "bg-gray-lighter rounded-l px-5 py-2",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                                                    className: style_default().dynamic([
                                                                                        [
                                                                                            "f7cc29c296bf819b",
                                                                                            [
                                                                                                websiteStatics,
                                                                                                websiteStatics,
                                                                                                websiteStatics
                                                                                            ]
                                                                                        ]
                                                                                    ]) + " " + "font-bold",
                                                                                    children: [
                                                                                        donationItem.customer_firstname,
                                                                                        ","
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: style_default().dynamic([
                                                                                        [
                                                                                            "f7cc29c296bf819b",
                                                                                            [
                                                                                                websiteStatics,
                                                                                                websiteStatics,
                                                                                                websiteStatics
                                                                                            ]
                                                                                        ]
                                                                                    ]) + " " + "ml-1",
                                                                                    children: donationItem.region
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                            style: {
                                                                                backgroundColor: "#F6F5F5"
                                                                            },
                                                                            className: style_default().dynamic([
                                                                                [
                                                                                    "f7cc29c296bf819b",
                                                                                    [
                                                                                        websiteStatics,
                                                                                        websiteStatics,
                                                                                        websiteStatics
                                                                                    ]
                                                                                ]
                                                                            ]) + " " + "px-5 py-2 rounded-r",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                                    className: style_default().dynamic([
                                                                                        [
                                                                                            "f7cc29c296bf819b",
                                                                                            [
                                                                                                websiteStatics,
                                                                                                websiteStatics,
                                                                                                websiteStatics
                                                                                            ]
                                                                                        ]
                                                                                    ]) + " " + "font-bold",
                                                                                    children: (0,helpers/* formatPrice */.T4)(Number(donationItem.row_total), "int")
                                                                                }),
                                                                                " ",
                                                                                "lei"
                                                                            ]
                                                                        })
                                                                    ]
                                                                }, "donation-item-".concat(i));
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: style_default().dynamic([
                                                        [
                                                            "f7cc29c296bf819b",
                                                            [
                                                                websiteStatics,
                                                                websiteStatics,
                                                                websiteStatics
                                                            ]
                                                        ]
                                                    ]) + " " + "cmsDonatie mb-16",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                            className: style_default().dynamic([
                                                                [
                                                                    "f7cc29c296bf819b",
                                                                    [
                                                                        websiteStatics,
                                                                        websiteStatics,
                                                                        websiteStatics
                                                                    ]
                                                                ]
                                                            ]) + " " + "font-bold",
                                                            children: "Donatiile partenerilor nostri"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: style_default().dynamic([
                                                                [
                                                                    "f7cc29c296bf819b",
                                                                    [
                                                                        websiteStatics,
                                                                        websiteStatics,
                                                                        websiteStatics
                                                                    ]
                                                                ]
                                                            ]) + " " + "flex flex-col sm:flex-row flex-wrap",
                                                            children: this.partnersDonations.map(function(donation, index) {
                                                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                                    className: style_default().dynamic([
                                                                        [
                                                                            "f7cc29c296bf819b",
                                                                            [
                                                                                websiteStatics,
                                                                                websiteStatics,
                                                                                websiteStatics
                                                                            ]
                                                                        ]
                                                                    ]) + " " + "mb-12 w-full sm:w-1/2 shrink-0",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AmountFlipCounter, {
                                                                            amount: donation.amount
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: style_default().dynamic([
                                                                                [
                                                                                    "f7cc29c296bf819b",
                                                                                    [
                                                                                        websiteStatics,
                                                                                        websiteStatics,
                                                                                        websiteStatics
                                                                                    ]
                                                                                ]
                                                                            ]) + " " + "text-lg mt-2 font-bold",
                                                                            children: donation.name
                                                                        })
                                                                    ]
                                                                }, index);
                                                            })
                                                        })
                                                    ]
                                                }),
                                                !!cmsObjBlocks.donatie_covid_stiri && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: style_default().dynamic([
                                                        [
                                                            "f7cc29c296bf819b",
                                                            [
                                                                websiteStatics,
                                                                websiteStatics,
                                                                websiteStatics
                                                            ]
                                                        ]
                                                    ]) + " " + "pb-4",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: style_default().dynamic([
                                                                [
                                                                    "f7cc29c296bf819b",
                                                                    [
                                                                        websiteStatics,
                                                                        websiteStatics,
                                                                        websiteStatics
                                                                    ]
                                                                ]
                                                            ]) + " " + "cmsDonatie",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                    className: style_default().dynamic([
                                                                        [
                                                                            "f7cc29c296bf819b",
                                                                            [
                                                                                websiteStatics,
                                                                                websiteStatics,
                                                                                websiteStatics
                                                                            ]
                                                                        ]
                                                                    ]) + " " + "font-normal",
                                                                    children: "Afla cum salvam vieti impreuna"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    _style: {
                                                                        marginLeft: 10,
                                                                        marginRight: 10
                                                                    },
                                                                    className: style_default().dynamic([
                                                                        [
                                                                            "f7cc29c296bf819b",
                                                                            [
                                                                                websiteStatics,
                                                                                websiteStatics,
                                                                                websiteStatics
                                                                            ]
                                                                        ]
                                                                    ]) + " " + "mt-4 mb-4",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                        title: showNews ? "Mai putine detalii" : "Mai multe detalii",
                                                                        display: "inline",
                                                                        size: "small",
                                                                        variant: "primary",
                                                                        onClick: function() {
                                                                            return _this.setState({
                                                                                showNews: !showNews
                                                                            });
                                                                        }
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        showNews && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: style_default().dynamic([
                                                                [
                                                                    "f7cc29c296bf819b",
                                                                    [
                                                                        websiteStatics,
                                                                        websiteStatics,
                                                                        websiteStatics
                                                                    ]
                                                                ]
                                                            ]) + " " + "cmsDonatie text-left",
                                                            children: !!cmsObjBlocks.donatie_covid_stiri && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentEditorView/* default */.Z, {
                                                                content: cmsObjBlocks.donatie_covid_stiri
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: style_default().dynamic([
                                                        [
                                                            "f7cc29c296bf819b",
                                                            [
                                                                websiteStatics,
                                                                websiteStatics,
                                                                websiteStatics
                                                            ]
                                                        ]
                                                    ]) + " " + "cmsDonatie text-left",
                                                    children: !!cmsObjBlocks.donatie_covid_jos && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentEditorView/* default */.Z, {
                                                        content: cmsObjBlocks.donatie_covid_jos
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: style_default().dynamic([
                                                        [
                                                            "f7cc29c296bf819b",
                                                            [
                                                                websiteStatics,
                                                                websiteStatics,
                                                                websiteStatics
                                                            ]
                                                        ]
                                                    ]) + " " + "text-red-brand text-3xl text-center font-thin mt-8",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: style_default().dynamic([
                                                                [
                                                                    "f7cc29c296bf819b",
                                                                    [
                                                                        websiteStatics,
                                                                        websiteStatics,
                                                                        websiteStatics
                                                                    ]
                                                                ]
                                                            ]),
                                                            children: "Fiecare donatie conteaza!"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: style_default().dynamic([
                                                                [
                                                                    "f7cc29c296bf819b",
                                                                    [
                                                                        websiteStatics,
                                                                        websiteStatics,
                                                                        websiteStatics
                                                                    ]
                                                                ]
                                                            ]),
                                                            children: "Iti multumim pentru implicare!"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                            title: "Doneaza si tu!",
                                                            display: "inline",
                                                            size: "normal",
                                                            variant: "primary",
                                                            href: "#doneaza-si-tu"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: style_default().dynamic([
                                                [
                                                    "f7cc29c296bf819b",
                                                    [
                                                        websiteStatics,
                                                        websiteStatics,
                                                        websiteStatics
                                                    ]
                                                ]
                                            ]) + " " + "lg:w-2/12"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }));
            }
        }
    ], [
        {
            key: "getInitialProps",
            value: function getInitialProps(ctx) {
                return _asyncToGenerator(runtime_default().mark(function _callee() {
                    var reduxStore, donationReportReq;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                reduxStore = ctx.reduxStore;
                                if (websiteName !== "altex") {
                                    if (ctx.res) {
                                        ctx.res.statusCode = 404;
                                    }
                                }
                                _ctx.next = 4;
                                return reduxStore.dispatch((0,actions/* getCmsBlocks */.lD)([
                                    "donatie_covid",
                                    "donatie_covid_jos",
                                    "donatie_covid_total",
                                    "donatie_covid_stiri", 
                                ]));
                            case 4:
                                _ctx.next = 6;
                                return reduxStore.dispatch((0,actions/* apiCall */.k_)({
                                    spinner: false,
                                    apiCall: api/* getDonationReportApi */.aDM,
                                    returnResponse: true
                                }));
                            case 6:
                                donationReportReq = _ctx.sent;
                                return _ctx.abrupt("return", {
                                    donationReport: donationReportReq && donationReportReq.data && donationReportReq.data.data ? donationReportReq.data.data : null
                                });
                            case 8:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        }
    ]);
    return DonatieCovid19;
}(react.Component);
DonatieCovid19.pageLayout = "default";
DonatieCovid19.layoutProps = {
    // hideHeader: true,
    // hideFooter: true,
    // hideTopBar: true,
    noContainer: true
};
/* harmony default export */ var donatie_impreuna = ((0,es/* connect */.$j)(function(state) {
    return {
        cart: state.cart,
        user: state.user,
        cmsObjBlocks: state.app.cmsObjBlocks
    };
}, {
    initCartToken: cart_actions/* initCartToken */.Ef,
    apiCall: actions/* apiCall */.k_,
    removeSpinner: actions/* removeSpinner */.eu,
    addSpinner: actions/* addSpinner */.pK,
    getCart: cart_actions/* getCart */.dv,
    getDummyCart: cart_actions/* getDummyCart */.oW
})(DonatieCovid19));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1423,5866,1961,8443,9774,2888,179], function() { return __webpack_exec__(63544); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);